<template>
  <div class="d-flex pl-3 pt-1 pb-1 bg-light-fracture1 rounded-top" v-if="inspectPlaceDbData">
    <h4 class="flex-grow-1 modal-title align-self-center">{{$t('検査箇所.1')}}</h4>
    <div class="align-self-center mr-1">
      <el-dropdown v-if="false" trigger="click" @command="onClickOption" class="wipe-menu-zindex ml-1 mr-1" >
        <el-tooltip class="box-item wipe-menu-zindex" popper-class="wipe-menu-zindex" effect="dark" content="オプション" placement="top" virtual-triggering >
          <el-button class=" text-primary" style="width:40px;" circle ><i class="fas fa-bars"></i></el-button>
        </el-tooltip>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item :command="0"><i class="fas fa-external-link-alt"></i>通知する</el-dropdown-item>
            <el-dropdown-item divided :command="1"><i class="fas fa-trash-alt"></i>削除する</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
        <base-button
          v-if="editPlaceId"
          @click="onClickMakeNoice"
          type="neutral"
          icon
          size="sm"
        >
          <span class="btn-inner--icon"
            ><i class="fas fa-external-link-alt"></i
          ></span>
          <span class="btn-inner--text">メッセージ送信</span>
        </base-button>

        <base-button
          v-if="editPlaceId"
          @click="onClickDeletePlace"
          type="neutral"
          icon
          size="sm"
        >
          <span class="btn-inner--icon"
            ><i class="fas fa-trash-alt"></i
          ></span>
          <span class="btn-inner--text">削除</span>
        </base-button>

    </div>
  </div>
  <div class="pl-3 pr-0 pb-3 pt-0" v-if="inspectPlaceDbData">
    <el-tabs
      type="card"
      class="demo-tabs mt-1"
    >
      <el-tab-pane name="0">
        <template #label>
          <span class="font-size-middle font-weight-bold">フォーム入力</span>
        </template>

        <div class="overflow-auto pt-2 pb-2" style="max-height:70vh;border-top:0px solid silver;border-bottom:0px solid silver;">
          <div class="px-2">
            <!-- 検査マスタ -->
            <h4 class="formInput-section" v-if="isChangeInspectResult" ><i class="fas fa-clipboard-list mr-2"></i>{{$t('検査箇所.4')}}</h4>
            <h4 class="formInput-section" v-if="currentInspectMaster && !isChangeInspectResult"><i class="fas fa-clipboard-list mr-2"></i>フォーム設定 : {{ currentInspectMaster.inspectMaster.name }}</h4>
            <div class="mb-3 pl-4">
              <el-select placeholder=""
                v-if="isChangeInspectResult"
                v-bind:disabled="!isChangeInspectResult"
                v-model="inspectPlaceDbData.inspectPlace.inspectMasterId"
                @change="chengeInspectMaster"

                filterable>
                <el-option v-for="item in viewModel.inspectMasterList"
                          class="select-primary"
                          :value="item.inspectMaster.id"
                          :label="item.inspectMaster.name"
                          :key="item.inspectMaster.name">
                </el-option>
              </el-select>
            </div>
            <!-- アイコン -->
            <h4 class="formInput-section">{{statusName}}</h4>
            <div class="d-flex flex-row align-items-center" v-if="currentInspectMaster">
              <!-- リスト選択 -->
              <img :src="iconKeyToPath[inspectPlaceDbData.inspectPlace.iconId]" class="bg-white avatar mr-3" v-if="iconKeyToPath[inspectPlaceDbData.inspectPlace.iconId]" style="display:inline-block;" />
              <el-select
                placeholder=""
                @change="chengeIcon"
                v-if="currentInspectMaster.inspectMaster.iconSelectType=='1'"
                size="small"

                v-model="inspectPlaceDbData.inspectPlace.iconId"
                >

                <el-option v-for="icon in this.iconSettingList"
                          class="select-primary"
                          :value="icon.id"
                          :label="icon.name"
                          :key="icon.id">
                          <img class="statusIcon" :src="iconKeyToPath[icon.id]" /><span class="ml-1">{{icon.name}}</span>
                </el-option>
                <template #prefix>
                  <img class="statusIcon" :src="iconKeyToPath[inspectPlaceDbData.inspectPlace.iconId]" />
                </template>
              </el-select>

              <!-- ボタン選択 -->
              <div v-if="currentInspectMaster.inspectMaster.iconSelectType=='2'" class="no-radio">
                <el-radio-group v-model="inspectPlaceDbData.inspectPlace.iconId" fill="#E4007F">
                  <div class="d-flex flex-wrap">
                    <div
                      class="ml-1 mb-1 mr-1"
                      v-for="(item, index) in this.iconSettingList"
                      :key="item.id">
                      <el-radio :label="item.id" size="large" border>
                        <img class="statusIcon" :src="iconKeyToPath[item.id]" />
                        {{item.name}}
                      </el-radio>
                    </div>
                  </div>
                </el-radio-group>
              </div>
            </div>
            <h4 class="formInput-section">{{$t('検査箇所.6')}}</h4>
            <!-- テキスト -->
            <el-form ref="placeForm" @submit.prevent :rules="rules" :model="inspectPlaceDbData.inspectPlace" label-position="top">
              <el-form-item prop="name">
                <el-input
                  name="name"
                  placeholder="テキストで入力"
                  v-model="inspectPlaceDbData.inspectPlace.name"
                ></el-input>
              </el-form-item>
            </el-form>

          </div>

          <div class="px-2 mt-2" v-if="inspectResult && inspectResult.inspectResultSet && inspectResult.inspectResultSet.inspectList">
            <h4 class="formInput-section">{{$t('検査箇所.5')}}</h4>
            <div class="d-flex flex-column pl-4">
              <div
                class=""
                v-for="resultItem in inspectResult.inspectResultSet.inspectList"
                :key="resultItem.itemId"
              >
                <!-- ラベル -->
                <h5 v-if="resultItem.itemType == `0`" >{{resultItem.value}}</h5>

                <h5 v-if="resultItem.itemType != `0`">{{resultItem.name}}<require-tag v-if="resultItem.required" /></h5>
                <el-form :ref="`resultForm${resultItem.itemId}`" @submit.prevent :rules="rules[resultItem.itemId]" :model="resultItem" label-position="top">
                  <!-- テキスト -->
                  <div v-if="resultItem.itemType == `1`">
                    <el-form-item prop="value">
                      <el-input
                        name="value"
                        placeholder="テキストで入力"
                        v-model="resultItem.value"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <!-- 数値 -->
                  <div v-if="resultItem.itemType == `2`">
                    <el-form-item prop="value">
                      <el-input
                        name="value"
                        placeholder="数値で入力"
                        v-model="resultItem.value"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <!-- 日付 -->
                  <div v-if="resultItem.itemType == `3`">
                    <el-form-item prop="value">
                      <el-date-picker
                        name="value"
                        v-model="resultItem.value"
                        type="datetime"
                        class="inline-input flex-fill"
                        placeholder="日付を選択"
                        :shortcuts="[{text: '今日', value: new Date()}]"
                        :disabled-date="disabledDate"
                        value-format="YYYY-MM-DD HH:mm:ss"
                        format="YYYY/MM/DD HH:mm:ss"
                        clearable
                      />
                    </el-form-item>
                  </div>
                </el-form>

                <!-- 選択 (リスト) -->
                <base-input name="select" v-if="resultItem.itemType == `4`">
                  <el-select placeholder=""
                    v-model="resultItem.valueId"
                    filterable>
                    <el-option v-for="item in getInputList(resultItem.itemId)"
                              class="select-primary"
                              :value="item.id"
                              :label="item.name"
                              :key="item.id">
                    </el-option>
                  </el-select>
                </base-input>
                <!-- 選択 (ボタン) -->
                <base-input name="selectButton" v-if="resultItem.itemType == `5`">
                  <div class="btn-group btn-group-toggle d-flex flex-wrap no-radio" >
                    <el-radio-group v-model="resultItem.valueId" fill="#E4007F">
                      <div class="d-flex flex-wrap">
                        <div
                          class="ml-1 mb-1 mr-1"
                          v-for="(item, index) in getInputList(resultItem.itemId)"
                          :key="index">
                          <el-radio :label="item.id" size="large" border>
                            {{item.name}}
                          </el-radio>
                        </div>
                      </div>
                    </el-radio-group>
                  </div>
                </base-input>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane name="1">
        <template #label>
          <span class="font-size-middle font-weight-bold">写真</span>
        </template>
        <div class="px-2" style="min-height:300px;" v-if="inspectResult">
          <div class="d-flex flex-column mt-1 d-flex my-box-light flex-wrap">
            <div class="">
              <div class="mb-2 mt-2 overflow-auto" style="max-height:300px" v-if="!isCustomized">
                <el-image
                  v-for="thumb in thumbList"
                  :key="thumb"
                  style="width:130px;height:130px;"
                  class="m-1 "
                  :src="thumb"
                  :preview-src-list="photoList"
                  :fit="`cover`">
                  </el-image>
              </div>
              <div class="mb-2 mt-2 overflow-auto" style="max-height:400px" v-if="isCustomized">
                <div v-for="memoItem in memoList" :key="memoItem" style="width:130px;height:185px;" class="el-image m-1">
                  <el-image
                    style="width:130px;height:130px;"
                    class="m-1 "
                    :src="memoItem.thumb"
                    :preview-src-list="photoList"
                    :fit="`cover`">
                    </el-image>
                    <el-input
                      v-model="memoItem.memo"
                      style="width: 126px;margin-top: -8px;margin-left: 4px;"
                      readonly="true"
                    >
                      <template #suffix>
                        <el-icon size="20" @click="onClickPhotoMemo(memoItem.filePath, 0)"><Edit class="text-primary" /></el-icon>
                      </template>
                    </el-input>
                </div>
              </div>
            </div>
          </div>
          <!-- <h4 class="formInput-section"><i class="far fa-file-image mr-2"></i>{{$t('検査箇所.3')}}</h4> -->
          <div class="d-flex flex-column mt-1 pl-0">
            <div class="">
              <div v-if="uploadFileList.length > 0">
                <small>未アップロード写真 {{uploadFileList.length}}枚</small>
              </div>
              <el-upload
                class="upload-demo m-1"
                action=""
                :on-change="handleOnChange"
                :on-remove="handleRemove"
                :file-list="uploadFileList"
                :multiple="true"
                :auto-upload="false"
                list-type="picture-card"
              >
                <el-button size="small" type="primary" class="mb-0">写真を選択</el-button>
                <template #file="{ file }">
                  <div>
                    <div style="width: 146px;height: 146px;">
                      <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                    </div>
                    <span class="el-upload-list__item-actions">
                      <span
                        class="el-upload-list__item-preview"
                        @click="handlePictureCardPreview(file)"
                      >
                        <el-icon><zoom-in /></el-icon>
                      </span>
                      <span
                        v-if="!disabled"
                        class="el-upload-list__item-delete"
                        @click="handleDownload(file)"
                      >
                        <el-icon><Download /></el-icon>
                      </span>
                      <span
                        v-if="!disabled"
                        class="el-upload-list__item-delete"
                        @click="handleRemove(file)"
                      >
                        <el-icon><Delete /></el-icon>
                      </span>
                    </span>
                  </div>
                  <el-input
                    v-if="isCustomized"
                    v-model="file.memo"
                    readonly="true"
                  >
                    <template #suffix>
                      <el-icon size="20" @click="onClickUploadPhotoMemo(file, 1)"><Edit class="text-primary" /></el-icon>
                    </template>
                  </el-input>
                </template>
              </el-upload>
              <el-dialog v-model="dialogVisible">
                <img w-full class="w-100" :src="dialogImageUrl" alt="Preview Image" />
              </el-dialog>
            </div>
          </div>

        </div>
      </el-tab-pane>
    </el-tabs>
    <div class="d-flex mt-4 mr-3">
      <div class="my-box flex-fill pr-1">
        <base-button
          block
          type="secondary"
          @click="onClickCancelPlace"
          >キャンセル</base-button
        >
      </div>
      <div class="my-box flex-fill pl-1">
        <base-button
          block
          type="primary"
          @click="onClickSavePlace"
          >保存</base-button
        >
      </div>
    </div>
  </div>
  <modal v-model:show="noticeModal" size="lg" style="z-index:1051 !important;" body-classes="p-0">
    <insplace-place-notice v-if="noticeModal" @noticeCancel="onClickNoticeCancel" @noticeSave="onClickNoticeSave" />
  </modal>
  <!-- 確認用モーダル -->
    <modal v-model:show="showConfirm" v-if="showConfirm" style="z-index:1052 !important;" body-classes="p-0">
      <confirm-modal
        :title="confirm.title"
        :message="confirm.message"
        :leftButtonLabel="confirm.leftButtonLabel"
        :rightButtonLabel="confirm.rightButtonLabel"
        @onClickLeftButton="onClickConfirmLeft"
        @onClickRightButton="onClickConfirmRight"
       />
    </modal>
  <modal v-model:show="memoModal" :maskClickClose="false" size="lg" style="z-index:1051 !important;" body-classes="p-0">
    <insplace-photo-memo
      v-if="memoModal"
      :memo="memo"
      :filePath="photoFilePath"
      :index="photoIndex"
      :mode="photoMemoMode"
      @photoMemoCancel="onClickPhotoMemoCancel"
      @photoMemoSave="onClickPhotoMemoSave"
    />
  </modal>
</template>
<style>
.no-radio .el-radio__input {
  display: none;
}

.el-upload--picture-card{
  /* width: 100% !important;
  height: 100px !important; */
  line-height: 100px !important;
  justify-content: center;
  align-items: center;
}

.el-upload-list__item{
  /* width: 120px !important;
  height: 120px !important; */
  height: auto !important;
  max-height: 187px;
}
.el-upload-list__item-thumbnail{
  object-fit: cover;
}
.el-collapse-item__header {
  background-color: #705470 !important;
  color: white !important;
  padding-left: 8px;
  height: 48vh;
  margin-top: 2px;
  margin-left: -8px;
  margin-right: -8px;
  border-radius: 1px;
  font-weight: bold;
}

</style>
<style scoped>
.active {
  color: white;
  background-color: #e4007f;
}
.active:hover {
  color: white;
}
.drawer-container {
  align-items: flex-start;
  background-color:white;
  opacity: 1.0;
}
.input-container {
  align-items: flex-start;
  background-color:white;
  opacity: 1.0;
  height: 80vh;
}
.header {
  position: sticky;
  top: 0;
  background-color:white;
  opacity: 1.0;
  z-index: 1010;
}

</style>

<script>
import InspectPlaceModel from "@/appModel/InspectPlace/InspectPlaceModel"
import InspectResultModel from "@/appModel/InspectResult/InspectResultModel"
import FileUtil from "../../appUtils/FileUtil"
import FileInput from "@/components/Inputs/FileInput";
import UserInfo from '../../appUtils/UserInfo';
import path from 'path'
import mime from 'mime-types';
import constants from "@/Config/constants"
import TenantStorage from "@/appUtils/TenantStorage"
import UserModel from "@/appModel/users/UserModel";
import NoticeModel from "@/appModel/Notice/NoticeModel"
import InspectPlaceViewModel from "@/appViews/InspectPlace/ViewModel/InspectPlaceViewModel"
import s3Util from "@/awsUtil/s3Util";
import InsplacePlaceNotice from "@/appViews/InspectPlace/Modal/InspectPlaceNotice"
import InsplacePhotoMemo from "@/appViews/InspectPlace/Modal/PhotoMemo"
import { Delete, Download, Plus, ZoomIn, Edit } from '@element-plus/icons-vue'
import DateUtil from '../../appUtils/DateUtil';
import ValidateUtil from "@/appUtils/ValidateUtil"
import CustomizeUtil from "../../appUtils/CustomizeUtil";
import { useToast } from "vue-toastification";

export default {
  components: {
    FileInput,
    InsplacePlaceNotice,
    InsplacePhotoMemo,
    Delete,
    Download,
    Plus,
    ZoomIn,
    Edit
  },
  props: {

    /**
     * プロジェクトID
     */
    projectId: {
      type: String,
      default: "2F47bBSU4tyrFDnqhmuMGA",
    },
    /**
     * ノードID
     */
    nodeId: {
      type: String,
      default: "mSRe8zwA4r8N9NkMpH21Zw",
    },
    /**
     * 検査マスタID
     *
     */
    inspectMasterId: {
      type: String
    },
    /**
     * 図面で検査箇所選択時にSplitFileViewから渡される検査箇所情報
     */
    editPlaceId: {
      type: Object
    },
    /**
     * 図面で新規箇所作成した情報
     */
    addPlaceData: {
      type: Object
    },
    /**
     * 検査箇所の場所（ツリーの論理名）通知登録時に使用
     */
    treePlace: {
      type: String
    }
  },
  computed: {
    statusName() {
      try {
        return this.currentInspectMaster.inspectMaster.statusName
      } catch (e) {
        return ""
      }
    },
    placeId() {
      if (this.addPlaceData) {
        return this.addPlaceData.inspectPlace.placeId
      } else {
        return this.editPlaceId
      }
    },
    isChangeInspectResult() {

      return !this.editPlaceId

    }
  },
  methods: {
    /**
     * 初期化処理
     */
    async init() {
      try {
        this.showLoader()

        // カスタマイズレコードを取得する
        let customizeRecord = await CustomizeUtil.checkCustomizeRecords(this.tenantId);

        // カスタマイズ機能判定
        this.isCustomized = customizeRecord.key === CustomizeUtil.customizeSumigomu

        await this.getProjectUsers()

        console.log(`inspectPlace init ${this.projectId}, ${this.nodeId}, ${this.placeId}, ${this.editPlaceId}`)
        const tenantStore = this.$store.state.tenant
        this.tenantId = tenantStore.id

        this.tenantStorage = new TenantStorage(this.tenantId)
        this.viewModel = new InspectPlaceViewModel(this.tenantId, this.projectId, this.nodeId, this.editPlaceId)

        await this.viewModel.init(this.addPlaceData)
        console.log(`検査結果 ${JSON.stringify(this.viewModel.inspectResult)}`)

        // 選択中のマスタ
        this.currentInspectMaster = this.viewModel.activeInspectMaster()

        // アイコン設定
        this.iconSettingList = this.currentInspectMaster.inspectMaster.iconSetting

        // アイコンをS3から取得
        const s3 = new s3Util()
        const iconList = this.iconSettingList
        for (let i = 0;i < iconList.length;i++) {
          const id = iconList[i].id
          const key = iconList[i].iconFilePath
          const url = await s3.getUrl(iconList[i].iconFilePath)
          this.iconKeyToPath[id] = url
          console.log(`id ${id} key: ${key} url: ${url}`)
        }

        // 検査箇所をセット
        this.inspectPlaceDbData = this.viewModel.inspectPlace

        // 箇所の編集であるか
        if (this.editPlaceId) {
          // 検査結果をセット
          this.inspectResult = this.viewModel.inspectResult.length > 0 ? this.viewModel.inspectResult[0] : null
          // 写真リスト作成
          this.makePhotoList()
        }

        // 検査マスタをセットアップ
        this.initInputForm()

        // 検査マスタIDが指定されている場合はマスタリスト選択は表示しない
        this.showInspectMasterList = !this.inspectMasterId
      } catch (e) {
        switch (e.message) {
        case "NOINSPECTPLACE":
          this.runToast("箇所情報の取得に失敗しました。", "error")
          break
        case "NOACTIVEMASTER":
          this.runToast("指定された検査フォームがありません。", "error")
          break
        case "NOMASTERLIST":
          this.runToast("有効な検査フォームがありません。", "error")
          break
        default:
          this.runToast("箇所情報の取得に失敗しました。", "error")
        }

        this.$emit('cancelPlace', { values: {}});

      } finally {
        this.hideLoader()
      }
    },

    async getProjectUsers() {
      this.users = await UserModel.getUserList(this.tenantId);
    },

    tabSelect(tab, event) {
      switch (tab.props.name) {
      case "tab1":
        this.changeTab(1)
        break
      case "tab2":
        this.changeTab(2)
        break
      case "tab3":
        this.changeTab(3)
        break
      }
    },

    /**
     * タブ切り替え時のハンドラ
     */
    changeTab(tabNum) {
      console.log(`changeTab ${tabNum}`)

      // 一旦全て非表示にする
      this.tab1Show = false
      this.tab2Show = false
      this.tab3Show = false

      //UI更新後の処理でタブ表示切り替えを行う。
      this.$nextTick(function() {
        switch (tabNum) {
        case 1:
          this.tab1Show = true
          break
        case 2:
          this.tab2Show = true
          break
        case 3:
          this.tab3Show = true
          break
        }
      }.bind(this))
    },

    /**
     * 検査マスタリスト選択変更時
     * ※箇所作成時点で使用するマスタは決定されているのでこの処理は開発用
     */
    chengeInspectMaster() {
      // 一旦非表示
      this.iconPath = null
      this.currentInspectMaster = null
      this.inspectPlaceDbData.inspectPlace.iconId = null
      this.inspectResult = null

      // UI更新後に処理
      this.$nextTick(function() {
        this.initInputForm()
      }.bind(this))
    },

    /**
     * 選択されているマスタ内容で検査項目を作成
     */
    initInputForm() {
      // 検査箇所情報にセットされているマスタIDを取得
      const masterId = this.inspectPlaceDbData.inspectPlace.inspectMasterId
      console.log(`masterId: ${masterId}`)

      // 検査マスタリストから該当するものを取得
      const selectedMaster = this.viewModel.inspectMasterList.filter(function(item){
        console.log(`item.id ${item.inspectMaster.id}`)
        return item.inspectMaster.id == masterId
      }.bind(this))

      // マスタ件数が1件以上ある場合
      if (selectedMaster.length > 0) {
        // 基本1件
        this.currentInspectMaster = selectedMaster[0]
      }

      this.iconSettingList = this.currentInspectMaster.inspectMaster.iconSetting

      // アイコンをS3から取得
      const s3 = new s3Util()
      const iconList = this.iconSettingList
      for (let i = 0;i < iconList.length;i++) {
        const id = iconList[i].id
        const key = iconList[i].iconFilePath
        // const url = await s3.getUrl(iconList[i].iconFilePath)
        s3.getUrl(iconList[i].iconFilePath).then(function(result) {
          this.iconKeyToPath[id] = result
          console.log(`id ${id} key: ${key} url: ${result}`)
        }.bind(this))
      }

      if (!this.inspectPlaceDbData.inspectPlace.iconId) {
        this.inspectPlaceDbData.inspectPlace.iconId = this.iconSettingList[0].id
      }

      if (this.currentInspectMaster) {
        // バリデーションルールを動的に作成
        this.currentInspectMaster.inspectMaster.inspectItemList.forEach(function(item) {
          switch (item.itemType) {
          case "1": {
            // テキスト
            if (item.required) {
              this.rules[item.id] = { value: [{ required: true, validator: this.checkRequireText, trigger: 'blur' }]  }
            } else {
              this.rules[item.id] = { value: [{ required: true, validator: this.checkText, trigger: 'blur' }]  }
            }
            break
          }
          case "2": {
            // 数値
            if (item.required) {
              this.rules[item.id] = { value: [{ required: true, validator: this.checkRequireNum, trigger: 'blur' }]  }
            } else {
              this.rules[item.id] = { value: [{ required: true, validator: this.checkNum, trigger: 'blur' }]  }
            }
            break
          }
          case "3": {
            // 日付
            if (item.required) {
              this.rules[item.id] = { value: [{ required: true, validator: this.checkRequire, trigger: 'blur' }]  }
            }
            break
          }
          default: {
            //ラベル、リスト
            break
          }
          }
        }.bind(this))
      }

      /**
       * 検査結果レコードがあれば検査結果項目の定義で入力項目を用意する。
       * 検査結果レコードがなければ検査フォームの内容で入力項目を用意する。
       * 検査結果入力後に検査フォームを変更した場合
       */
      if (this.inspectResult == null) {
        console.log(`this.inspectResult is null`)

        // 検査結果がまだない場合は検査結果用の雛形を作成する
        InspectResultModel.getNewData(this.projectId, this.nodeId, this.placeId).then(function(result){
          this.inspectResult = result
          this.inspectResult.inspectResultSet.inspectList = []
          console.log(`this.inspectResult get`)
          const inspectList = []

          if (this.currentInspectMaster) {
            // マスタの項目定義分入力用の雛形を作成
            this.currentInspectMaster.inspectMaster.inspectItemList.forEach(function(item) {
              let defaultValue = item.defaultValue

              if (item.systemDateFlg) {
                defaultValue = DateUtil.dateStringDateTime()
              }

              // リスト・ボタンタイプの初期選択値をセットする
              let valueId = null
              switch (item.itemType) {
              case "4":
              case "5":{
                // マスタの選択項目から初期値と指定されている項目を取得する
                let defaultValue = item.items.filter(function(item){
                  return item.isDefault
                })
                // 選択IDをvalueIdに保持する
                if (defaultValue.length > 0) {
                  valueId = defaultValue[0].id
                }
                break
              }
              default:
                break;
              }

              inspectList.push({
                itemId: item.id,
                value: defaultValue,
                valueId: valueId,
                name: item.name,
                itemType: item.itemType,
                required: item.required,
                order: item.order,

              })
              //this.currentInspectMaster.inspectMaster.inspectItemList
            }.bind(this));

            // 表示順でソート
            this.inspectResult.inspectResultSet.inspectList = inspectList.sort((a, b) => {
              console.log(`order: ${a.order} ${b.order}`)
              if (a.order < b.order) return -1;
              if (a.order > b.order) return 1;
              return 0;
            });

            // 編集確認用に保持
            this.defaultInspectResult = JSON.parse(JSON.stringify(this.inspectResult.inspectResultSet.inspectList));
          }
        }.bind(this))
      }
    },

    /**
     * アイコン変更時のハンドラ
     */
    chengeIcon() {
      // 検査箇所情報のチェック
      // if (this.inspectPlaceDbData) {
      //   // 選択したアイコン区分がセットされているかチェック
      //   if (this.inspectPlaceDbData.inspectPlace.iconId) {
      //     this.getIconPath(this.inspectPlaceDbData.inspectPlace.iconId).then(function(result) {
      //       // 取得結果をセット。
      //       this.iconPath = result
      //     }.bind(this))
      //   }
      // }
    },

    /**
     * アイコンクラスから検査アイコンのパスを取得
     */
    async getIconPath(iconId) {
      const iconList = this.iconSettingList;

      // アイコンリストから該当するアイコン情報を取得
      const iconDatas = iconList.filter(function(icon) {
        return icon.id == iconId
      }.bind(this))

      // アイコン情報取得チェック
      if (iconDatas.length > 0) {
        // S3上のリソースURLを取得
        console.log(`アイコンパス ${iconDatas[0].iconFilePath}`)
        return await FileUtil.getTenantFileUrl(iconDatas[0].iconFilePath)
      }
    },

    /**
     * 検査マスタIDから検査マスタを取得する
     */
    getInputMaster(id) {
      console.log(`getInputMaster:${id}`)

      if (this.currentInspectMaster) {
        const inputMasters = this.currentInspectMaster.inspectMaster.inputMaster.filter(function(InputMaster) {
          console.log(`${InputMaster.id} ${id}`)
          return InputMaster.id == id
        }.bind(this))

        console.log(`getInputMaster: inputMasters.lengh ${inputMasters.length}`)

        if (inputMasters.length > 0) {
          console.log(inputMasters[0].list)
          return inputMasters[0].list
        }
      }

      return []
    },

    getInputList(id) {
      try {
        console.log(`getInputList ${id}`)

        if (!id){
          return []
        }

        if (this.currentInspectMaster) {
          const inspectItem = this.currentInspectMaster.inspectMaster.inspectItemList.filter(function(inspectItem) {
            return inspectItem.id == id
          }.bind(this))[0]

          console.log(`getInputList ${JSON.stringify(inspectItem.items)}`)

          return inspectItem.items
        }
      } catch (e) {
        console.log(JSON.stringify(e))
        throw e
      }
    },

    /**
     * キャンセルボタン押下時
     */
    onClickCancelPlace() {
      // this.$emit('transfer', {key: "inspectPlaceCancel", values: {}});
      this.$emit('cancelPlace', { values: {}});
    },

    /**
     * 保存ボタン押下時
     */
    async onClickSavePlace() {
      console.log(`onClickSavePlace`)

      try {
        this.$refs.placeForm.validate(async function(result) {
          if (!result) {
            this.runToast("入力内容にエラーがあります。", "error")
            return
          }

          // フォーム項目数分のループを回す
          const inspectItemList = this.currentInspectMaster.inspectMaster.inspectItemList
          const list = inspectItemList.map(item => {
            return item.id
          })

          this.validateItem(list, function() {
            // すべて完了後に保存処理
            try {
              this.saveProc()
            } catch (e) {
              console.log(e.stack)
              this.runToast("箇所情報の保存時にエラーが発生しました。", "error")
              this.$emit('cancelPlace', { values: {}});
            }

          }.bind(this))
        }.bind(this))
      } catch (e) {
        console.log(e.stack)
        this.runToast("箇所情報の保存時にエラーが発生しました。", "error")
        this.$emit('cancelPlace', { values: {}});
      }
    },

    async validateItem(list, callBack) {
      let _list = list
      const id = _list.shift()

      if (this.$refs[`resultForm${id}`]) {
        this.$refs[`resultForm${id}`].validate(async function(result) {
          if (!result) {
            this.runToast("入力内容にエラーがあります。", "error")
            return
          }

          if (_list.length > 0) {
            this.validateItem(_list, callBack)
          } else {
            callBack()
          }
        }.bind(this))
      } else {
        if (_list.length > 0) {
          this.validateItem(_list, callBack)
        } else {
          callBack()
        }
      }
    },

    async saveProc() {
      try {
        this.showLoader();

        if (this.uploadFileList.length > 0) {
          // 写真のアップロード
          const s3KeyList = await this.uploadPhotos(this.uploadFileList)

          // 検査結果レコードに写真情報を追加
          let cnt = 0
          s3KeyList.forEach(function(key) {
            const order = this.inspectResult.inspectResultSet.photoList.length ? this.inspectResult.inspectResultSet.photoList.length : 0

            let memo = ""
            if (this.uploadFileList.length > cnt) {
              memo = this.uploadFileList[cnt].memo
            }

            this.inspectResult.inspectResultSet.photoList.push({
              filePath: key,
              order: order,
              isWrite: false,
              memo: memo
            })

            cnt++
          }.bind(this))

          console.log(`inspectPlaceDbData ${JSON.stringify(this.inspectPlaceDbData, null, "\t")}`)
        }

        if (this.addPlaceData) {
          // 追加
          InspectPlaceModel.addInspectPlace(this.inspectPlaceDbData).then(function() {
            // 検査結果
            console.log(`inspectResult ${this.inspectResult}`)

            if (this.inspectResult) {
              //let resultSk = InspectResultModel.createSkForList(this.projectId, this.nodeId, this.placeId)
              InspectResultModel.getInspectResultList(this.projectId, this.nodeId, this.placeId, this.tenantId).then(function(resultList) {
                if (resultList.length > 0) {
                  // 保存
                  InspectResultModel.updateInspectResult(this.inspectResult)
                } else {
                  // 追加
                  InspectResultModel.addInspectResult(this.inspectResult)
                }
              }.bind(this))
            }

            const data = Object.assign({}, this.inspectPlaceDbData)

            // this.$emit('transfer', {key: "inspectPlaceAddComplete", values: data});
            this.$emit('addComplete', {values: data});
          }.bind(this))
        } else if (this.editPlaceId) {
          // 更新
          InspectPlaceModel.updateInspectPlace(this.inspectPlaceDbData).then(function() {
            // 検査結果
            console.log(`inspectResult ${this.inspectResult}`)

            // 保存
            InspectResultModel.updateInspectResult(this.inspectResult)

            const data = Object.assign({}, this.inspectPlaceDbData)
            // this.$emit('transfer', {key: "inspectPlaceEditComplete", values: data});
            this.$emit('editComplete', {values: data});
          }.bind(this))
        }

        // マスタのロックフラグを更新
        await this.viewModel.updateInspectMasterFlg()
      } catch (e) {
        console.log(JSON.stringify(e))
        throw e
      } finally {
        this.hideLoader();
      }
    },

    handleOnChange(file, fileList){
      this.uploadFileList = fileList
    },

    handleRemove(file, fileList){
      this.uploadFileList = fileList
    },

    async uploadPhotos(files){
      // const user = await UserInfo.getUserInfo()
      const user = await this.$root.getUserInfo()
      const s3KeyPrefix = `${constants.s3_tenant_prefix}/${user.group}/`

      const s3KeyBase = `project_${this.projectId}/node_${this.nodeId}/place_${this.inspectPlaceDbData.inspectPlace.placeId}/result_${this.inspectResult.inspectResultSet.id}/`
      const s3KeyList = []

      try {
        for (let i = 0; i < files.length;i++) {
          const contentType = mime.lookup(files[i].name)

          // S3Keyはルートから指定する
          const s3Key = await this.tenantStorage.createPlacePhotoKey(this.projectId, this.nodeId, this.inspectPlaceDbData.inspectPlace.placeId, this.inspectResult.inspectResultSet.id, files[i].name)
          await this.tenantStorage.put(s3Key, files[i].raw)

          s3KeyList.push(s3Key)
        }
      } catch (e) {
        console.log(`アップロードエラー ${JSON.stringify(e)}`)
        throw e
      }

      return s3KeyList
    },

    makePhotoList() {
      this.thumbList = []
      this.photoList = []

      this.$nextTick(function() {
        if (!this.inspectResult){
          return
        }

        if (!this.inspectResult.inspectResultSet){
          return
        }

        this.inspectResult.inspectResultSet.photoList.forEach(function(item){
          // 一覧表示に使用するサムネイル写真のURLリストを作成
          const thumbKey = `${path.dirname(item.filePath)}/thumb-${path.basename(item.filePath)}`
          const origianlKey = `${path.dirname(item.filePath)}/${path.basename(item.filePath)}`

          this.tenantStorage.get(thumbKey).then(function(result){
            // FileUtil.getTenantFileUrl(thumbKey).then(function(result){
            console.log(`サムネイルOK`)
            this.thumbList.push(result.toBase64())
            this.memoList.push({thumb: result.toBase64(), filePath: item.filePath, memo: item.memo})
          }.bind(this)).catch(function(error) {
            this.tenantStorage.get(origianlKey).then(function(result){
              this.thumbList.push(result.toBase64())
              this.memoList.push({thumb: result.toBase64(), filePath: item.filePath, memo: item.memo})
            }.bind(this))
          }.bind(this))

          // プレビューに使用するフルサイズ写真のURLを取得(クリックしたときに取得しないとまずい)
          const photoKey = `${path.dirname(item.filePath)}/${path.basename(item.filePath)}`
          this.tenantStorage.get(photoKey).then(function(result){
            // FileUtil.getTenantFileUrl(photoKey).then(function(result){
            this.photoList.push(result.toBase64())
          }.bind(this))
        }.bind(this))
      }.bind(this))
    },

    /**
     * 処理中インジケーターを表示します。
     * @returns 表示したインジケーター
     */
    showLoader() {
      this.loader = this.$loading.show({
        container: null,
        canCancel: false,
        color: "#E4007F",
        width: 64,
        height: 64,
        backgroundColor: "#ffffff",
        opacity: 0.5,
        isFullPage: true,
        zIndex: 9999,
      })
    },

    handleRemove(file) {
      console.log(file)
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },

    handleDownload(file) {
      console.log(file)
    },

    /**
     * 処理中インジケーターを閉じます。
     * @paramas {Object} loader 表示したインジケーター
     */
    hideLoader() {
      this.loader.hide();
    },

    handleChange(val) {
      console.log(val);
    },

    onClickConfirmLeft() {
      this.confirm.leftButtonFn()
    },

    onClickConfirmRight() {
      this.confirm.rightButtonFn()
    },

    async onClickMakeNoice() {
      this.noticeModal = false
      let notice = this.$store.state.notice
      notice.linkedId = this.viewModel.inspectPlace.sk
      notice.treePlace = this.treePlace
      this.$store.commit("setNotice", notice)
      this.noticeModal = true
    },

    async onClickDeletePlace() {
      await this.deletePlace()
    },

    async onClickOption(command) {
      this.noticeModal = false

      switch (command) {
      case 0: {
        let notice = this.$store.state.notice
        notice.linkedId = this.viewModel.inspectPlace.sk
        notice.treePlace = this.treePlace
        this.$store.commit("setNotice", notice)
        this.noticeModal = true

        break
      }
      case 1: {
        await this.deletePlace()
        break
      }
      default:{
        break
      }
      }
    },

    onClickNoticeCancel() {
      this.noticeModal = false
    },

    onClickNoticeSave() {
      this.noticeModal = false
    },

    async deletePlace() {
      try {
        // 変更確認
        this.confirm.message = `検査箇所を削除します。よろしいですか？`
        this.confirm.leftButtonLabel = "キャンセル"
        this.confirm.rightButtonLabel = "削除"

        this.confirm.leftButtonFn = function() {
          this.showConfirm = false
        }.bind(this)

        this.confirm.rightButtonFn = async function() {
          this.showConfirm = false

          // 削除する
          try {
            await this.viewModel.deleteInspectPlace()
            this.$emit('inspectPlaceDeleteComplete');
          } catch (e) {
            console.log(e.stack)
            this.runToast("箇所情報の削除時にエラーが発生しました。", "error")
            this.$emit('cancelPlace', { values: {}});
            return
          }
        }.bind(this)

        this.showConfirm = true
      } catch (e) {
        console.log(e.stack)
        this.runToast("箇所情報の削除時にエラーが発生しました。", "error")
        this.$emit('cancelPlace', { values: {}});
      }
    },

    /**
     * 写真備考アイコンクリックイベント
     * @param filePath S3上での写真のファイルパス
     * @param mode 写真備考追加・編集モード
     */
    onClickPhotoMemo(filePath, mode) {
      this.memo = this.inspectResult.inspectResultSet.photoList.filter(function(item) {
        return item.filePath == filePath
      }.bind(this))[0].memo

      this.photoFilePath = filePath
      this.photoIndex = 0
      this.photoMemoMode = mode
      this.memoModal = true;
    },

    /**
     * アップロード写真備考アイコンクリックイベント
     * @param file 画像ファイル情報
     * @param mode 写真備考追加・編集モード
     */
    onClickUploadPhotoMemo(file, mode) {
      this.memo = file.memo;
      this.photoIndex = file.uid
      this.photoMemoMode = mode
      this.memoModal = true;
    },

    /**
     * 写真備考表示・編集画面 キャンセルボタン押下イベント
     */
    onClickPhotoMemoCancel() {
      this.memoModal = false;
    },

    /**
     * 写真備考表示・編集画面 OKボタン押下イベント
     * @param data 写真備考
     * @param filePath S3上での写真のファイルパス
     * @param index サムネイルリストインデックス
     * @param mode 写真備考追加・編集モード
     */
    onClickPhotoMemoSave(data, filePath, index, mode) {
      this.memoModal = false;
      let memo = data

      if (mode === 0) {
        const list = this.inspectResult.inspectResultSet.photoList
        for (let i = 0; i < list.length; i++) {
          if (list[i].filePath === filePath) {
            this.inspectResult.inspectResultSet.photoList[i].memo = memo
            break;
          }
        }

        for (let i = 0; i < this.memoList.length; i++) {
          if (this.memoList[i].filePath === filePath) {
            this.memoList[i].memo = memo
            break;
          }
        }
      } else {
        for (let i = 0; i < this.uploadFileList.length; i++) {
          if (index === this.uploadFileList[i].uid) {
            this.uploadFileList[i].memo = memo;
          }
        }
      }
    },

    /**
     * 箇所名の入力チェック
     */
    async checkName(rule, value, callback){
      if (ValidateUtil.checkBase(value, callback, 100, true, false, false, true)) {
        callback()
      }
    },

    async checkRequireText(rule, value, callback) {
      if (ValidateUtil.checkBase(value, callback, 100, true, false, false, true)) {
        callback()
      }
    },

    async checkRequireNum(rule, value, callback) {
      if (ValidateUtil.checkBase(value, callback, 100, true, false, true, true)) {
        callback()
      }
    },

    async checkNum(rule, value, callback) {
      if (ValidateUtil.checkBase(value, callback, 100, false, false, true, true)) {
        callback()
      }
    },

    async checkText(rule, value, callback) {
      if (ValidateUtil.checkBase(value, callback, 100, false, false, false, true)) {
        callback()
      }
    },

    async checkRequire(rule, value, callback) {
      if (ValidateUtil.checkBase(value, callback, 100, true, false, false, false)) {
        callback()
      }
    },

    // ----------------
    // トースト
    // ----------------
    /**
     * トースト表示
     */
    runToast(message, type) {
      const pos = 'bottom-center'
      const toast = useToast();

      toast[type](message, {
        hideProgressBar: true,
        icon: false,
        toastClassName: ["custome-toast-class"],
        closeButton: false,
        position: pos,
        id: this.toastId
      });
    },

    /**
     * トースト非表示
     */
    hideToast() {
      const toast = useToast();
      toast.dismiss(this.toastId)
    },
  },

  beforeCreate() {
    //インスタンスは生成されたがデータが初期化される前
  },

  created() {
    //インスタンスが生成され､且つデータが初期化された後
  },

  beforeMount() {
    //インスタンスが DOM 要素にマウントされる前
  },

  mounted() {
    //インスタンスが DOM 要素にマウントされた後
    this.init().then(() => {
      console.log("call init")
    })
  },

  beforeUpdate() {
    //データは更新されたが DOM に適用される前
  },

  updated() {
    //データが更新され､且つ DOM に適用された後
  },

  beforeUnmount() {
    //Vue インスタンスが破壊される前
  },

  unmounted() {
    //Vue インスタンスが破壊された後
  },

  data() {
    return {
      tenantId: null,
      inspectPlaceDbData: null,
      inspectResult: null,
      inspectMasterList: null,
      currentInspectMaster: null,
      tab1Show: true,
      tab2Show: false,
      tab3Show: false,
      iconPath: null,
      activeTab: "tab1",
      showInspectMasterList: true,
      resultTypes: [
        {value: "", label: "未判定"},
        {value: "0", label: "合格"},
        {value: "1", label: "不合格"},
      ],
      thumbList: [],
      photoList: [],
      uploadFileList: [],
      tenantStorage: null,
      // activeNames: ['inspectPlace']
      activeNames: ['inspectPlace', 'inspectResult', 'inspectPicture', 'notice'],
      activeStyle: [{'background-color': 'primary'}],
      defaultInspectResult: null,
      users: [],
      noticeData: null,
      noticeContent: "",
      selectedUsers: [],
      viewModel: null,
      // systemIconFileList: [
      //   {"type": "1", "name": "青丸", "key": constants.iconpath.icon1, "path": "blank" },
      //   {"type": "2", "name": "緑丸", "key": constants.iconpath.icon2, "path": "blank" },
      //   {"type": "3", "name": "灰丸", "key": constants.iconpath.icon3, "path": "blank" },
      //   {"type": "4", "name": "赤丸", "key": constants.iconpath.icon4, "path": "blank" },
      //   {"type": "5", "name": "黄丸", "key": constants.iconpath.icon5, "path": "blank" },
      //   {"type": "6", "name": "青星", "key": constants.iconpath.icon6, "path": "blank" },
      //   {"type": "7", "name": "緑星", "key": constants.iconpath.icon7, "path": "blank" },
      //   {"type": "8", "name": "灰星", "key": constants.iconpath.icon8, "path": "blank" },
      //   {"type": "9", "name": "赤星", "key": constants.iconpath.icon9, "path": "blank" },
      //   {"type": "10", "name": "黄星", "key": constants.iconpath.icon10, "path": "blank" },
      //   {"type": "11", "name": "青三角", "key": constants.iconpath.icon11, "path": "blank" },
      //   {"type": "12", "name": "緑三角", "key": constants.iconpath.icon12, "path": "blank" },
      //   {"type": "13", "name": "灰三角", "key": constants.iconpath.icon13, "path": "blank" },
      //   {"type": "14", "name": "赤三角", "key": constants.iconpath.icon14, "path": "blank" },
      //   {"type": "15", "name": "黄三角", "key": constants.iconpath.icon15, "path": "blank" },
      // ],
      // systemIconFileList: constants.sumigomuicon,
      iconKeyToPath: {},
      iconSettingList: [],
      loader: null,
      noticeModal: false,
      showConfirm: false,
      confirm: {
        title: "削除確認",
        message: "",
        leftButtonLabel: "キャンセル",
        rightButtonLabel: "削除",
        leftButtonFn: null,
        rightButtonFn: null
      },
      dialogImageUrl: null,
      dialogVisible: false,
      toastId: "inspectPlace",
      isCustomized: false,
      memoModal: false,
      memo: "",
      photoIndex: 0,
      photoFilePath: null,
      memoList: [],
      photoMemoMode: 0,
      rules: {
        name: [{ required: true, validator: this.checkName, trigger: 'blur' }],
        // requireText: [{required: true, validator: this.checkRequireText, trigger: 'blur'}],
        // requireNum: [{required: true, validator: this.checkRequireNum, trigger: 'blur'}],
        // num: [{required: false, validator: this.checkNum, trigger: 'blur'}],
        // text: [{required: false, validator: this.checkText, trigger: 'blur'}],
        // require: [{required: true, validator: this.checkRequire, trigger: 'blur'}],
      }

    }
  }
}
</script>
